export const ImageUploadStatusEnum = { Not_Uploaded: 0, Uploaded: 1 };
export const ImageUploadSizeEnum = { MaxSize: 100000 };



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ImageUploadStatusEnum.js